import React, { useEffect } from 'react'
import { CenterImg, CloseIconWrapper, Wrapper } from './atoms'
import CloseIcon from './image/close-icon.webp'
import { customSessionStorage, isTestUrl } from '../../utils'
import { LOCALE } from '@foxrenderfarm/internals'
// import centerEn from './image/center-en.webp'
// import centerDe from './image/center-de.webp'
// import centerEs from './image/center-es.webp'
// import centerFr from './image/center-fr.webp'
// import centerIt from './image/center-it.webp'
// import centerJp from './image/center-jp.webp'
// import centerKr from './image/center-kr.webp'
// import centerPt from './image/center-pt.webp'
// import centerRu from './image/center-ru.webp'
// import centerTr from './image/center-tr.webp'

import centerEn from './image/promotion/center-en.webp'
import centerDe from './image/promotion/center-de.webp'
import centerEs from './image/promotion/center-es.webp'
import centerFr from './image/promotion/center-fr.webp'
import centerIt from './image/promotion/center-it.webp'
import centerJp from './image/promotion/center-jp.webp'
import centerKr from './image/promotion/center-kr.webp'
import centerPt from './image/promotion/center-pt.webp'
import centerRu from './image/promotion/center-ru.webp'
import centerTr from './image/promotion/center-tr.webp'
// import { getRegisterLink, UserAuthorizationService } from '@foxrenderfarm/common'

const infos: { [key in string]: { img: string; id: string; alt: string; bg?: string } } = {
  [LOCALE.EN]: {
    img: centerEn,
    id: 'EGP-topup2',
    alt: '20% Bonus On your First Recharge',
  },
  [LOCALE.DE]: {
    img: centerDe,
    id: 'EGP-topup2',
    alt: '20% Bonus Bei Ihrer ersten Aufladung',
  },
  [LOCALE.ES]: {
    img: centerEs,
    id: 'EGP-topup2',
    alt: 'Descuento del 20% En tu primera recarga',
  },
  [LOCALE.FR]: {
    img: centerFr,
    id: 'EGP-topup2',
    alt: 'Bonus de 20% Sur votre premier rechargement',
  },
  [LOCALE.IT]: {
    img: centerIt,
    id: 'EGP-topup2',
    alt: '20% di bonus Sulla tua prima ricarica',
  },
  [LOCALE.JP]: {
    img: centerJp,
    id: 'jp_recharge',
    alt: '20％ボーナス 初回チャージ時に',
  },
  [LOCALE.KR]: {
    img: centerKr,
    id: 'kr_recharge',
    alt: '20% 보너스 첫 충전 시 적용',
  },
  [LOCALE.PT]: {
    img: centerPt,
    id: 'pt-banner',
    alt: 'Bônus de 20% No seu Primeiro Depósito',
  },
  [LOCALE.RU]: {
    img: centerRu,
    id: 'EGP-topup2',
    alt: '20% бонус На ваш первый депозит',
  },
  [LOCALE.TR]: {
    img: centerTr,
    id: 'EGP-topup2',
    alt: '20% Bonus İlk Yükleme İşleminizde',
  },
}

interface Props {
  locale: LOCALE
  showTopBanner: boolean
  handleShowTopBanner: (v: boolean) => void
}

// const localeUrls: Partial<{ [key in LOCALE]: string }> = {
//   [LOCALE.DE]: '/news/weihnachts-super-sale-2024-fox-renderfarm/',
//   [LOCALE.ES]: '/news/super-venta-navidena-2024-fox-renderfarm/',
//   [LOCALE.PT]: '/news/super-promocao-de-natal-2024-da-fox-renderfarm/',
//   [LOCALE.FR]: '/news/super-vente-de-noel-2024-fox-renderfarm/',
//   [LOCALE.IT]: '/news/super-saldi-di-natale-2024-fox-renderfarm/',
//   [LOCALE.TR]: '/news/noel-sueper-indirimi-2024-fox-renderfarm/',
//   [LOCALE.RU]: '/news/rozhdestvenskaya-super-rasprodazha-2024-fox-renderfarm-volnitelnoe/',
// }

export const TopBanner = ({ showTopBanner, handleShowTopBanner, locale }: Props) => {
  useEffect(() => {
    customSessionStorage.removeItem('fox_top_hide')
  }, [handleShowTopBanner, locale])

  const handleClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault()
    handleShowTopBanner(false)
    customSessionStorage.setItem('fox_top_hide', '1')
  }

  const currentInfo = infos[locale]

  // const href = UserAuthorizationService.isLogined()
  //   ? `${baseUrl}/center/user/topUp`
  //   : getRegisterLink(locale)
  const isPage = [LOCALE.KR, LOCALE.JP].includes(locale)
  const href = isTestUrl()
    ? `http://pre.foxrenderfarm.com${isPage ? `/${locale}` : ''}/promotion.html?utm_source=website&utm_medium=display&utm_campaign=2025midyearsale_top`
    : `https://foxrenderfarm.com${isPage ? `/${locale}` : ''}/promotion.html?utm_source=website&utm_medium=display&utm_campaign=2025midyearsale_top`

  return showTopBanner ? (
    <Wrapper as='a' href={href} target='_blank' id={currentInfo?.id || ''} bg={currentInfo?.bg}>
      <CenterImg src={currentInfo.img} alt={currentInfo.alt} loading='lazy' />
      <CloseIconWrapper src={CloseIcon} alt='close' onClick={handleClose} loading='lazy' />
    </Wrapper>
  ) : null
}
